export default __webpack_public_path__ + "static/media/kar98k.bc3e6112.svg";